export default "__VITE_ASSET__DHrYbLhO__"